import { LanguagesEnum } from 'common/enums/languages'

import { IWbAppInfo } from '@interco/inter-webview-bridge'

export const normalizeLanguage = (
  lang: string | null,
  defaultLanguage: LanguagesEnum = LanguagesEnum.EN_US,
): LanguagesEnum => {
  if (!lang) return defaultLanguage

  if (lang.includes('pt')) return LanguagesEnum.PT_BR
  if (lang.includes('en')) return LanguagesEnum.EN_US
  if (lang.includes('es')) return LanguagesEnum.ES_ES

  return defaultLanguage
}

// appLanguage is the deprecated iOS-only field (pre-unified bridge versions). Some iOS app
// releases still don't send the unified `language` field, so fall back to it if present.
export const resolveDeviceLanguage = (appInfo?: Partial<IWbAppInfo>): string | null =>
  appInfo?.language ?? appInfo?.appLanguage ?? null
